import React from 'react';
import classnames from 'classnames';

type Props = {
  className?: string;
  size?: number;
  color?: string;
};

export const CheckIcon = (props: Props) => {
  const { className } = props;
  const size = props.size || 24;
  const color = props.color || undefined;

  const classList = classnames('check-icon', className);

  const styles = {
    width: size,
    height: size,
  };

  return (
    <svg
      className={classList}
      style={styles}
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
        fill={color}
      />
    </svg>
  );
};
